export default "__VITE_ASSET__efd56549__"